import React from "react"
import Modal from "react-modal"
import PropTypes from "prop-types"
import theme from "./theme"

Modal.setAppElement("#root")

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    color: theme.colours.text.secondary,
    backgroundColor: theme.colours.paperSolid,
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.55)",
    zIndex: 3,
  },
}

const Dialog = ({ isOpen, onRequestClose, contentLabel, children }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel={contentLabel}
    >
      {children}
    </Modal>
  )
}

Dialog.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  contentLabel: PropTypes.string,
  children: PropTypes.any,
}

export default Dialog
